// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers'

import {ModifyPosition} from './modify-position.js'

export class ModifyPositions {
  bb: flatbuffers.ByteBuffer | null = null
  bb_pos = 0
  __init(i: number, bb: flatbuffers.ByteBuffer): ModifyPositions {
    this.bb_pos = i
    this.bb = bb
    return this
  }

  static getRootAsModifyPositions(bb: flatbuffers.ByteBuffer, obj?: ModifyPositions): ModifyPositions {
    return (obj || new ModifyPositions()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  static getSizePrefixedRootAsModifyPositions(bb: flatbuffers.ByteBuffer, obj?: ModifyPositions): ModifyPositions {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH)
    return (obj || new ModifyPositions()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  modifications(index: number, obj?: ModifyPosition): ModifyPosition | null {
    const offset = this.bb!.__offset(this.bb_pos, 4)
    return offset
      ? (obj || new ModifyPosition()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!
        )
      : null
  }

  modificationsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4)
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0
  }

  static startModifyPositions(builder: flatbuffers.Builder) {
    builder.startObject(1)
  }

  static addModifications(builder: flatbuffers.Builder, modificationsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, modificationsOffset, 0)
  }

  static createModificationsVector(builder: flatbuffers.Builder, data: flatbuffers.Offset[]): flatbuffers.Offset {
    builder.startVector(4, data.length, 4)
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!)
    }
    return builder.endVector()
  }

  static startModificationsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4)
  }

  static endModifyPositions(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject()
    builder.requiredField(offset, 4) // modifications
    return offset
  }

  static createModifyPositions(
    builder: flatbuffers.Builder,
    modificationsOffset: flatbuffers.Offset
  ): flatbuffers.Offset {
    ModifyPositions.startModifyPositions(builder)
    ModifyPositions.addModifications(builder, modificationsOffset)
    return ModifyPositions.endModifyPositions(builder)
  }
}
